const sectionProductsList = document.querySelectorAll('.products-list');

/* SWIPER */

let productsListSwiper = new Swiper(".products-list .swiper", {
  pagination: {
    el: ".products-list .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".products-list .swiper-button-next",
    prevEl: ".products-list .swiper-button-prev",
  },
  loop: false,
  centeredSlides: false,
  slidesPerView: 2,
  spaceBetween: 0,
  autoHeight: false,
  breakpoints: {
      749: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
});
  
if (typeof apparitionFromRight === 'undefined') {
  
  const apparitionFromRight = document.querySelectorAll('.apparition-from-right');
  
  const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              entry.target.classList.add('animate');
          }
      });
  }, {
      threshold: 0.1,
  });
  
  apparitionFromRight.forEach((el) => observer.observe(el));
    
}

/* TAB TRANSITION */

sectionProductsList.forEach(productList => {

  // TAB

  productList.querySelectorAll('.products-list__tabs .tab__item').forEach(tab => {
  
    tab.addEventListener('click', () => {
  
      productList.querySelectorAll('.products-list__tabs .tab__item').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
  
      productList.querySelectorAll('.products-list__contents .contents__item').forEach(content => {
        content.classList.remove('active');
        content.style.display = 'none';
      });
   
      const sectionProductsListContents = productList.querySelectorAll('.products-list__contents .contents__item');
      const newContent = Array.from(sectionProductsListContents).find(content => content.id === tab.id);
  
      if (newContent) {
        newContent.style.display = 'block';
  
        setTimeout(() => {
          newContent.classList.add('active');
        }, 10);
        
      }
      
    });
  
  });

  
  const productListItems = productList.querySelectorAll('.product__item');

  productListItems.forEach(productItem => {

    // THUMBNAILS

    const productItemFeaturedImage = productItem.querySelector('.item__image .image img');
    const productItemThumbnailVariant = productItem.querySelectorAll('.variant-thumbnails .thumbnail__variant');
    
    productItemThumbnailVariant.forEach(thumbnail => {

      thumbnail.addEventListener('click', () => {

        const featuredImage = thumbnail.dataset.featuredImage;

        if (featuredImage) {
          productItemFeaturedImage.src = featuredImage;
          productItemFeaturedImage.srcset = featuredImage;
        }

        // BORDER

        productItemThumbnailVariant.forEach(thumbnail => {
          thumbnail.removeAttribute('active');
        })
        thumbnail.setAttribute('active', '');

      });
    });
    
  })

})

/* PRODUCTS HREF */

const productItemContents = document.querySelectorAll('.products-list__contents .product__item .item__content');

productItemContents.forEach(content => {
  content.addEventListener('click', (e) => {
    e.stopPropagation(); 
    const product = content.closest('.product__item');
    const productPageUrl = product.dataset.href;
    if (productPageUrl) {
      window.location.href = productPageUrl.trim(); 
    }
  });
});

/* SWIPER IMAGES*/

let productsImageSwiper= new Swiper(".products-list .item__image.swiper-images", {
  scrollbar: {
    el: ".products-list .item__image .swiper-scrollbar",
    hide: false,
    draggable: true, 
  },
  loop: false,
  slidesPerView:1,
  autoHeight: false,
  breakpoints: {
      749: {
        slidesPerView: 1,
        spaceBetween: 20,
      }
    }
});